import { tabLeaveHandler } from "../../../frontend/www-static/javascript/es6/tab-leave-handler";

function getCookie(name) {
  const match = document.cookie.match(
    new RegExp("(?:^|; )" + name.replace(/([.$?*|{}()[\]\\/+^])/g, "\\$1") + "=([^;]*)")
  );
  return match ? decodeURIComponent(match[1]) : undefined;
}

function setCookie(name, value, days) {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = name + "=" + encodeURIComponent(value) + "; expires=" + expires + "; path=/";
}

function scrollbarWidth() {
  return window.innerWidth - document.documentElement.clientWidth;
}

export function subscribeShow() {
  const activeClass = "subscribe-active";
  const noCookieClass = "no-subscribe";
  const tabLeaveTriggerClass = "no-subscribe-leave";

  const cookie = getCookie("subscribe_close");
  const body = document.body;
  const isTabLeaveTrigger = body.classList.contains(tabLeaveTriggerClass);

  const popup = document.querySelector(".b-subscribe_modal");
  if (!popup) return;

  if (popup.dataset.type === "book_consultation") return;

  window.dataLayer = window.dataLayer || [];

  if (!body.classList.contains(activeClass) && !cookie && body.classList.contains(noCookieClass)) {
    const scrollWidth = scrollbarWidth();
    const scrollEmul = document.querySelector(".scroll-emul");
    if (scrollEmul) scrollEmul.style.width = scrollWidth + "px";

    const fixedEls = document.querySelectorAll(".fixed-panel-inner");

    function addActiveClass() {
      fixedEls.forEach((el) => {
        el.style.left = el.getBoundingClientRect().left + "px";
        el.style.right = "auto";
      });

      body.classList.add(activeClass);
      body.style.paddingRight = scrollWidth + "px";

      const pageHeader = document.querySelector(".page-header");
      if (pageHeader) pageHeader.style.right = scrollWidth + "px";

      document
        .querySelectorAll(".b-subscribe_modal-visual .subscribe-svg animateTransform, .b-subscribe_modal-visual .subscribe-svg animate")
        .forEach((el) => setTimeout(() => el.beginElement(), 800));

      dataLayer.push({ event: "popup_impression" });
    }

    if (isTabLeaveTrigger) {
      // Homepage: forced show after 40s + exit-intent — whichever fires first
      let shown = false;
      function showOnce() {
        if (shown) return;
        shown = true;
        addActiveClass();
      }

      const forceTimer = setTimeout(showOnce, 40000);

      tabLeaveHandler(() => {
        clearTimeout(forceTimer);
        showOnce();
      });
    } else {
      // Service / blog pages: 10s after first scroll
      document.addEventListener("scroll", () => setTimeout(addActiveClass, 10000), { once: true });
    }
  }

  document.querySelectorAll(".js-subscribe-close").forEach((btn) => {
    ["click", "touchstart"].forEach((evt) => {
      btn.addEventListener(evt, () => {
        body.classList.add("subscribed");
        setCookie("subscribe_close", "true", 365);
      });
    });
  });
}
